// src/components/goal-settings/KpiCreateModal.jsx
import React, { useState } from 'react';

export default function KpiCreateModal({
                                           show,
                                           kpaId,
                                           onClose,
                                           onCreated, // (payload) -> parent will call createKpi
                                       }) {

    const [name, setName] = useState('');
    const [threshold, setThreshold] = useState('');
    const [target, setTarget] = useState('');
    const [stretch, setStretch] = useState('');
    const [weight, setWeight] = useState('');
    const [isPercentage, setIsPercentage] = useState(false);
    const [unit, setUnit] = useState('');
    const [higherIsBetter, setHigherIsBetter] = useState(true);
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState('');

    if (!show) return null;
    
    const submit = async (e) => {
        e?.preventDefault?.();
        if (!name.trim()) return setErr('Name is required.');
        if (!weight || !Number.isFinite(Number(weight))) return setErr('Weight must be a number.');

        try {
            setSaving(true);
            setErr('');

            const payload = {
                key_performance_area_id: kpaId,
                name: name.trim(),
                threshold: threshold !== '' ? Number(threshold) : null,
                target:    target    !== '' ? Number(target)    : null,
                stretch:   stretch   !== '' ? Number(stretch)   : null,
                weight: Number(weight),
                is_percentage: !!isPercentage,
                unit: isPercentage ? null : (unit?.trim() || null),
                higher_is_better: !!higherIsBetter,
            };

            await onCreated?.(payload);
            onClose?.();
        } catch (e2) {
            setErr(e2?.response?.data?.message || 'Failed to create KPI.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="modal show" style={{ display: 'block', background: 'rgba(0,0,0,.4)' }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-md">
                <div className="modal-content">
                    <div className="modal-header py-2">
                        <h6 className="modal-title">Add KPI</h6>
                        <button type="button" className="btn-close" onClick={onClose} />
                    </div>

                    <form onSubmit={submit}>
                        <div className="modal-body">
                            {err && <div className="alert alert-danger py-1">{err}</div>}

                            <div className="mb-2">
                                <label className="form-label mb-1">Name <span className="text-danger">*</span></label>
                                <input className="form-control form-control-sm" value={name} onChange={e => setName(e.target.value)} autoFocus/>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <label className="form-label mb-1">Threshold</label>
                                    <input className="form-control form-control-sm" type="number" step="0.0001" value={threshold} onChange={e => setThreshold(e.target.value)} />
                                </div>
                                <div className="col-6">
                                    <label className="form-label mb-1">Target</label>
                                    <input className="form-control form-control-sm" type="number" step="0.0001" value={target} onChange={e => setTarget(e.target.value)} />
                                </div>
                            </div>

                            <div className="row mt-1">
                                <div className="col-6">
                                    <label className="form-label mb-1">Stretch</label>
                                    <input className="form-control form-control-sm" type="number" step="0.0001" value={stretch} onChange={e => setStretch(e.target.value)} />
                                </div>
                                <div className="col-6">
                                    <label className="form-label mb-1">Weight <span className="text-danger">*</span></label>
                                    <input className="form-control form-control-sm" type="number" step="0.0001" value={weight} onChange={e => setWeight(e.target.value)} />
                                </div>
                            </div>

                            <div className="form-check mt-2">
                                <input className="form-check-input" type="checkbox" id="kpiIsPct" checked={isPercentage} onChange={e => setIsPercentage(e.target.checked)} />
                                <label className="form-check-label" htmlFor="kpiIsPct">Percentage</label>
                            </div>

                            <div className="mt-2">
                                <label className="form-label mb-1">Unit</label>
                                <input className="form-control form-control-sm" value={unit} onChange={e => setUnit(e.target.value)} disabled={isPercentage} placeholder={isPercentage ? 'Disabled when %' : 'e.g., kg, items, days'} />
                            </div>

                            <div className="form-check mt-2">
                                <input className="form-check-input" type="checkbox" id="kpiHigherBetterCreate" checked={higherIsBetter} onChange={e => setHigherIsBetter(e.target.checked)} />
                                <label className="form-check-label" htmlFor="kpiHigherBetterCreate">
                                    Higher is better
                                    <div className="text-muted small">
                                        When on: higher actuals score better; when off: lower actuals score better.
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div className="modal-footer py-2">
                            <button type="button" className="btn btn-sm btn-light" onClick={onClose} disabled={saving}>Cancel</button>
                            <button type="submit" className="btn btn-sm btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Create'}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
